import axios from 'axios';

const url = '/api/templates';

const TemplateService = {
  getById(id) {
    return axios.get(`${url}/${id}`);
  },
  getAllTemplates() {
    return axios.get(`${url}/all`);
  },
  async getAllTemplatesOptions() {
    const response = await axios.get(`${url}/all`);
    const { data } = response;
    if (data) {
      return data.map((template) => ({
        value: template.id,
        label: template.title,
      }));
    }
    return null;
  },

  getAllContentBlocks() {
    return axios.get(`${url}/block`);
  },

  async getAllContentBlocksOptions() {
    const response = await axios.get(`${url}/blocks`);
    const { data } = response;
    if (data) {
      return data.map((contentBlock) => ({
        value: contentBlock.id,
        label: contentBlock.title,
      }));
    }
    return null;
  },
  async getAllContentBlocksTypes() {
    const response = await axios.get(`${url}/blocks`);
    const { data } = response;
    if (data) {
      return data;
    }
    return [];
  },
};

export default TemplateService;
